import React from "react";
import EmptyValue from "../../../components/EmptyValue";

// Extra react-table columns spliced into legacy's own Constants.QUOTATIONS_COLUMN
// (src/components/quotationsTable/Constants.js), the quotations-side twin of
// ../orders/columns.jsx. Both carried forward from the v2-native build this page
// replaces.

function textOr(value) {
    return value || <EmptyValue />;
}

export function buildExtraPharmacyQuotationColumns() {
    return [
        {
            Header: "Rx",
            accessor: "rxStatus",
            disableSortBy: true,
            Cell: (row) =>
                row.row.original?.prescription?.links?.length ? (
                    <span className="rounded-[10px] bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700">
                        Uploaded
                    </span>
                ) : (
                    <span className="rounded-[10px] bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-600">
                        Missing
                    </span>
                ),
        },
        {
            // orderId is the reliable conversion signal -- only ~12% of genuinely
            // converted quotations actually carry the CONVERTED_TO_ORDER status. See
            // src/v2/constants/quotation-status.js.
            Header: "Order Id",
            accessor: "orderId",
            disableSortBy: true,
            Cell: (row) => textOr(row.row.original?.orderId),
        },
    ];
}
